import baseAxios from './config/baseAxiosPublicServicos';
import { DefaultError } from '../constants/messages';
import { getNumbers, getDataStringEUA } from './../helpers/util';

export async function getRecaptchaChave() {
    let promise = new Promise(function (resolve, reject) {
        resolve(process.env.REACT_APP_GOOGLE_RECAPTCHA)
    });

    return promise;
}

export const postAuthenticate = async (username, password) => {
    const payload = {
        cpf: username,
        senha: password
    };

    return baseAxios.post('/v1/autenticacao/login', payload)
        .then(result => {
            const { data = {} } = result;
            return { ...result, user: data };
        });
};

export const postRefreshToken = async (token) => {
    const qs = require('qs');
    const payload = qs.stringify({
        refresh_token: token,
        grant_type: 'refresh_token'
    });

    return baseAxios.post('/v1/autenticacao/token', payload)
        .then(result => {
            const { data = {} } = result;
            return { ...result, user: data };
        })
        .catch((error) => {
            const msg = (error.messages && error.messages.length > 0)
                ? error.messages[0]
                : DefaultError;

            return { ...error, message: msg };
        });
};


export async function postPrimeiroAcessoCadastrarConta({
    cpf,
    matricula,
    dataNascimento,
    email,
    recaptcha }) {
    const payload = {
        cpf: getNumbers(cpf),
        matricula: getNumbers(matricula),
        dataNascimento: getDataStringEUA(dataNascimento),
        email: email,
        recaptcha: recaptcha,
    }
    return baseAxios.post(`/v1/autenticacao/primeiro-acesso`, payload);
}

export async function postPrimeiroAcessoCadastrarSenha(hashRecuperacaoSenha, senhaNova) {
    const payload = {
        novaSenha: senhaNova,
        hashSenhaRecuperacao: hashRecuperacaoSenha,
        ehRecuperacao: false
    }
    return baseAxios.post(`/v1/autenticacao/alteracao-senha`, payload);
}


export async function postConfirmarSenha(hashRecuperacaoSenha, senhaNova) {
    const payload = {
        novaSenha: senhaNova,
        hashSenhaRecuperacao: hashRecuperacaoSenha,
        ehRecuperacao: true
    }
    return baseAxios.post(`/v1/autenticacao/alteracao-senha`, payload);
};

export async function postRecuperarSenha({ cpf, email }) {
    const payload = {
        cpf: getNumbers(cpf),
        email: email
    }

    return baseAxios.post(`/v1/autenticacao/recuperacao-senha`, payload);
};